import React from 'react'

import { Box, Modal, Container, Typography, IconButton, Accordion, AccordionSummary, AccordionDetails, Popper } from '@mui/material'
import { ChevronLeft, ChevronRight, Close } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/system';
import NotificationsIcon from '@mui/icons-material/Notifications';

const NotificationAccordion = styled(Accordion)((props) => ({
    margin: '12px 0',
    borderRadius: '5px !important',
    boxShadow: 'none',
    background:'#F8FBFF',
    '&:before': {
        background: 'unset'
    },
    '& .MuiAccordionSummary-root:before': {
        width: '2px',
        height: '26px',
        content: '"-"',
        color: '#fff',
        borderTopRightRadius: '10px',
        borderBottomRightRadius: '10px',
        fontSize: '0.01px',
        position: 'absolute',
        left: '0',
    }
}))


const NotifictionItem = ({ title, description, read }) => <NotificationAccordion>
    <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
            '&:before': {
                background: read ? '#FFBF5F' : '#0CD6D4',
            }
        }}
    >
        <Typography
            fontSize={16}
            fontWeight={600}
        >{title}</Typography>
    </AccordionSummary>

    <AccordionDetails>
        <Typography
            color='#89939F'
            fontSize={13}>
            {description}
        </Typography>
    </AccordionDetails>
</NotificationAccordion>

export const NotificationDetail = ({ open, setOpen, anchorEl }) => {

    const style = {
        alignItems: 'flex-start',
        boxSizing: 'border-box',
        boxShadow: 24,
        bgcolor: '#F8F8FD',
        flexDirection: 'column',
        display: { xs: 'flex', lg: 'none' },
        height: '100%',
        top: '0%',
        position: 'absolute',
        p: 2,
        width: '100%',
    };


    const notifications = [
        { title: '1 عنوان اطلاع رسانی', description: 'لورم ایپسون متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است', id: 1, read: true },
        { title: 'عنوان اطلاع رسانی 2', description: 'لورم ایپسون متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است', id: 2, read: false },
        { title: '3 عنوان اطلاع رسانی', description: 'لورم ایپسون متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است', id: 3, read: false },
        { title: 'عنوان اطلاع رسانی 4', description: 'لورم ایپسون متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است', id: 4, read: true },
    ]


    const Content = (<>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%', p: { xs: 0, lg: 1 } }}>

            <IconButton
                onClick={() => setOpen(false)} sx={{ float: 'left', display: { xs: 'flex', lg: 'none' } }}>
                <ChevronRight sx={{ color: '#000' }} />
            </IconButton>

            <Box display={'flex'} alignItems='center'>
                <NotificationsIcon color='primary' sx={{ mr: 1.5 }} />
                <Typography
                    fontSize={16}
                    fontWeight={600}>اطلاع رسانی</Typography>
            </Box>

            <IconButton
                onClick={() => setOpen(false)} sx={{ float: 'left', display: { xs: 'flex', lg: 'none' } }}>
                <ChevronLeft sx={{ opacity: 0 }} />
            </IconButton>

        </Box>
        <Container maxWidth='sm' sx={{ my: 1 }}>
            {/* {notifications.map(notif => <NotifictionItem {...notif} />)} */}
        </Container></>)

    return (
        <>

            <Popper open={open} anchorEl={anchorEl} sx={{ display: { xs: 'none', lg: 'block' } }} placement='bottom-end'>
                <Box sx={{ boxShadow: '  -8px 0 11px rgba(0, 0, 0, 0.09)', p: 1, bgcolor: 'background.paper', zIndex: 2, borderRadius: '7px', overflowY: 'auto', overflowX: 'hidden', maxHeight: '300px' }}>
                    {Content}
                </Box>
            </Popper>


            <Modal
                open={open}
                onClose={() => setOpen(false)}
                sx={{ display: { xs: 'block', lg: 'none' } }}
            >
                <Box sx={style}>
                    {Content}
                </Box>
            </Modal>

        </>
    )
}
